import React from 'react';
export const MinusIcon = () => (/*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.25",
  d: "M3.75 12h16.5"
})));